import { createSlice } from '@reduxjs/toolkit';

const initialState = { verifying: false, error: null };

const m365Slice = createSlice({
	name: 'm365',
	initialState,
	reducers: {
		verifyConnection: (state) => {
			state.verifying = true;
			state.error = null;
		},
		verifyConnectionSuccess: (state) => {
			state.verifying = false;
		},
		verifyConnectionError: (state, action) => {
			state.verifying = false;
			state.error = action.payload;
		}
	},
	extraReducers: (builder) => {
		// Reset on logout so org A's in-flight verify/error never renders on org B.
		builder.addCase('auth/logout', () => initialState);
	}
});

export const m365Actions = m365Slice.actions;
export default m365Slice.reducer;
